import { ValueOfKey } from '../../utils-types';

export const TAX_RATE_TYPE = {
  APPLICATION_TAX_RATE: 'APPLICATION_TAX_RATE',
  ENTITY_TAX_RATE: 'ENTITY_TAX_RATE',
  SCAN_IQ_ENTITY_TAX_RATE: 'SCAN_IQ_ENTITY_TAX_RATE',
  CHALLENGE_TAX_RATE: 'CHALLENGE_TAX_RATE',
} as const;

export type TaxRateType = ValueOfKey<typeof TAX_RATE_TYPE>;
